module.exports = __webpack_public_path__ + "img/XAUR.0661303c.svg";